import React, { Component } from "react";
import {
  Layout,
  Dropdown,
  Menu,
  Icon,
  Row,
  Col,
  Input,
  Tooltip,
  Pagination,
  Spin,
  Popconfirm,
  Button,
} from "antd";
import { Link } from "react-router-dom";
// import Head from "../components/Head";
// import Foote from "../components/Footer";
// import ICP from "../components/ICP";
import default_head from "../../assets/head_default_img.png";
import "../../css/search-result.css";
import { api, app } from "../../app";
import config from "../../config";

const { Header, Content } = Layout;

class SearchResult extends Component {
  constructor(props) {
    super(props);
    // const search_type = props.match.params.search_type,
    // search_val = props.match.params.search_val;
    // let search_type_str = "姓名";
    this.state = {
      img:
        config.imgUrl +
        "/Uploads/jiaZheng99krltkerkewrewkrewkrewpkrekrpweewfe.jpg",
      token: "",
      isTrue: false,
      classList: [],
      resultList: [],
      list: [],
      class_loading: false,
      data_loading: false,
      page: 1,
      total: 0,
      search_type_str: "姓名",
      search_type: "searchform_name",
      search_val: "",
      search_val_flag: false,
    };
  }

  componentDidMount() {
    this.getTokeni();
    this._isMounted = true;
    this.setState({ date: this.props.date, list: this.props.list });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  /**
   * 获取token
   * @returns {Promise<void>}
   */
  getTokeni = async (e) => {
    let that = this;

    let { flag, data, msg } = await app.post(api.getToken);

    if (flag === 1) {
      // if (data.token == e) {
      //     // that.handleLoading();
      that.setState({
        token: data.token,
        data_loading: true,
      });
      let { resultList, list } = this.state;
      list.forEach((res) => {
        const obj = {
          name: res.vname,
          no: res.bsrno,
          localpath: res.portrait
            ? config.imgUrl + app.urlEncode(res.portrait)
            : default_head,
          indexno: res.indexno,
          team_id: res.team_id,
          identity: res.identity,
          uri: `/player/${res.team_id}/${res.user_id}/?token=${data.token}`,
          volunteer_id: res.user_id,
          kx: null,
        };
        if (res.volunteer_state === "4") {
          obj.kx = "已离队";
        } else if (res.volunteer_state === "5") {
          obj.kx = "已清退";
        }
        resultList.push(obj);
        this.setState({ resultList, data_loading: false });
      });
    } else {
      app.alert(msg, "warn");
    }
  };

  /**
   * 取消
   * @param id
   */
  handleDelete = async (res) => {
    const params = {
      account: app.getData("account"),
      user_id: res.volunteer_id,
      date: this.state.date,
      version_id: api.version_id,
    };
    let { flag, data, msg } = await app.post(api.dutyDelete, params);
    if (flag === 1) {
      let { onClose } = this.props;
      onClose(true);
    } else {
      app.alert(msg, "warn");
      let { onClose } = this.props;
      onClose(true);
    }
  };

  addDuty = async () => {
    let { onClose } = this.props;
    onClose(this.state.date);
  };

  

  getAdd = async (volunteer_id) => {};

  render() {
    const class_loading = this.state.class_loading,
      classList = this.state.classList,
      search_type_str = this.state.search_type_str,
      search_val = this.state.search_val,
      data_loading = this.state.data_loading,
      page = this.state.page,
      result_total = this.state.total,
      no_data = this.state.no_data,
      resultList = this.state.resultList || [],
      search_val_flag = this.state.search_val_flag,
      load_node = (
        <div className="loading">
          <Spin size="large" />
        </div>
      );
    return (
      <div className="search-result">
        <Layout>
          <Content>
            <div className="result-list">
              {data_loading
                ? load_node
                : resultList.length > 0
                ? resultList.map((res, index) => {
                    return (
                      <Col
                        key={index + 1}
                        className="item"
                        style={{ margin: "20px 0" }}
                      >
                        <Link to={res.uri}>
                          <div></div>
                          <div className="img">
                            <img src={res.localpath} alt="" />
                            {res.kx ? <div className="kx">{res.kx}</div> : null}
                          </div>
                          <p className="name">{res.name}</p>
                          <p className="num">{res.bottom_txt}</p>
                        </Link>
                        <Popconfirm
                          placement="bottom"
                          title="确定取消吗"
                          cancelText="取消"
                          okText="确定"
                          onConfirm={() => this.handleDelete(res)}
                        >
                          <Button type="danger">取消</Button>
                        </Popconfirm>
                      </Col>
                    );
                  })
                : no_data}
              {this.state.isTrue ? (
                <img
                  style={{
                    display: "block",
                    margin: "0 auto",
                    marginTop: "100px",
                  }}
                  src={this.state.img}
                  alt=""
                />
              ) : (
                ""
              )}
            </div>
            <Row>
              <Col span={12} style={{ textAlign: "right" }}>
                <Button
                  disabled={resultList.length == 2}
                  style={{ marginRight: "15px" }}
                  type="primary"
                  onClick={() => this.addDuty()}
                >
                  添加
                </Button>
              </Col>
            </Row>
          </Content>
        </Layout>
      </div>
    );
  }
}

export default SearchResult;



// WEBPACK FOOTER //
// ./src/routes/grade/Dutyexamine.jsx